export default __webpack_public_path__ + "static/media/landmark.f73ebbe3.svg";